<template>
  <v-app id="app" :class="backgroundClass">
    <AppNavbar />
    <AppHeader />
    <v-main>
      <router-view />
    </v-main>
    <AppFooter />
  </v-app>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppNavbar from './components/AppNavbar.vue'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppNavbar,
    AppHeader,
    AppFooter
  },
  setup() {
    const route = useRoute()
    const backgroundClass = computed(() => route.meta.backgroundClass || 'default-background')
    return { backgroundClass }
  }
}
</script>

<style>
body {
  height: 100%;
  width: 100%;
  font-family: 'Kanit', sans-serif;
  margin: 0;
}

#app {
  display: flex;
  flex-direction: column;
  /*height: 100vh;*/
}

/* Background classes */
.login-background {
  background-image: url('@/assets/login-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.home-background {
  background-image: url('@/assets/home-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.default-background {
  background-image: url('@/assets/default-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
